import { defineMessages } from 'react-intl';

export const organizationsMessages = defineMessages({
  error: {
    id: 'organization.search.error',
    defaultMessage: 'Failed to load organizations',
  },
  parentDSOLabel: {
    id: 'organization.parent.label',
    defaultMessage: 'Parent DSO',
  },
  searchPlaceholder: {
    id: 'organization.search.placeholder',
    defaultMessage: 'Search by name or email',
  },
});
